import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { getStoreCustomerAccount } from "../../services/StoreCustomerAccount/getStoreCustomerAccount";
import { orderMultiplePaymentSettlement, orderPaymentSettlement } from "../../services/OrderPayment/orderPayment";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import {
  GeneratePaymentLink,
} from "../../services/PaymentGatewayConfig/PaymentGatewayConfig";
import { useNavigate } from "react-router-dom";
import { setOrderPackageSubscription, setPackageSubscriptionOfferDefault } from "../../services/PaymentOfferManagement/CheckPackageSubscriptionOffer";
import { subscriberOffer } from "../../services/subscriberOffer/SubscriberOffer";
import CollectPaymentPackageSubscriptionOfferDefault from "./CollectPaymentPackageSubscriptionOfferDefault";
import { getLocalChargesAndDiscount, getLocalPaymentMode, getLocalStorePaymentGatewayConfig, getStoreLocalData } from "../../utils/localStorage";
import { STORE_BASE_URL } from "../../services/BaseURL";

import QRCode from "qrcode";
import { getCustomerSingleOrderInfo } from "../../services/OrdersAPI/Orders";


const DISPLAY_W = 320;
const DISPLAY_H = 480;

const CollectPaymentSubscriptionClosedModal = ({
  collectPaymentSubscriptionClosedModalVisible,
  setCollectPaymentSubscriptionClosedModalVisible,
  balanceAmount,
  storeCustomerId,
  storeId,
  storeUserId,
  bookingOrderId,
  status,
  text,
  sendResponse,
  sendResponseQrPayment,
  onClose,
  deliveryDiscount,
  enableUserAccountDeliveryDiscount,
  enabledCreatePaymentLink,
  brandId,
  enabledSubscriptionDiscountOnDelivery,
  subscriptionDiscount,
  appliedSubscriptionDiscount,
  paidAmount,
  userProfileData,
  enabledApplySubscriptionWithPackage,
  enabledAutoApplySubscriptionWithPackage,
  orderPackageData,
  enabledUPIAccount,
  upiAccountLink,
  upiAccountId,
  upiAccountName,
  bookingOrderNo,
  enabledQRDeviceModal,
  orderSubscriptionInfo,
  enabledAmountRoundOff
}) => {
  const navigate = useNavigate();
  const { storeLocalData } = getStoreLocalData();
  const [receiveAmountValue, setReceiveAmountValue] = useState("");
  const [balanceAmountValue, setBalanceAmountValue] = useState("");
  const [paymentMethodValue, setPaymentMethodValue] = useState("");
  const [paymentModeData, setPaymentModeData] = useState([]);
  const [isPayNowButtonPressed, setIsPayNowButtonPressed] = useState(false);
  const [storeCustomerAccountResponse, setStoreCustomerAccountResponse] =
    useState({});
  const [userAccountBalanceAmountError, setUserAccountBalanceAmountError] =
    useState("");
  const [userAccountLowBalanceError, setUserAccountLowBalanceError] = useState("")
  const [paymentSecondError, setPaymentSecondError] = useState("");
  const [receiveAmountSecondError, setReceiveAmountSecondError] = useState("");

  const [addDiscountValue, setAddDiscountValue] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [selectedDiscount, setSelectedDiscount] = useState([]);

  const [charges, setCharges] = useState([]);
  const [addDiscount, setAddDiscount] = useState({});

  const [discounts, setDiscounts] = useState([]);
  const [storePaymentGatewayData, setStorePaymentGatewayData] = useState([]);
  const [addMorePaymentMethod, setAddMorePaymentMethod] = useState(false);
  const [secondPaymentModeData, setSecondPaymentModeData] = useState([]);
  const [receiveAmountSecondValue, setReceiveAmountSecondValue] = useState("");
  const [paymentMethodSecondValue, setPaymentMethodSecondValue] = useState("");

  const [showQRModal, setShowQRModal] = useState(false);

  const isRoundOffMode = enabledAmountRoundOff === 0;

  const inputRegex = isRoundOffMode
    ? /^\d*$/
    : new RegExp(`^\\d*\\.?\\d{0,${enabledAmountRoundOff}}$`);


  const fetchLocalPaymentMode = async () => {
    const { paymentMode } = getLocalPaymentMode();
    if (paymentMode && Object.keys(paymentMode).length > 0) {

      let paymentModeList = [...paymentMode?.paymentModeList?.Location1];

      const paymentModeWithOutUA = paymentModeList.filter(
        (item) => item !== "USER_ACCOUNT"
      );
       
      let filteredModes = [...paymentModeWithOutUA];

      // Remove ICICI_PG only if QR device modal is enabled
      if (enabledQRDeviceModal) {
        filteredModes = filteredModes.filter(item => item !== "ICICI_PG");
      }

      // Remove ONLINE if payment link creation is disabled
      if (!enabledCreatePaymentLink) {
        filteredModes = filteredModes.filter(item => item !== "ONLINE");
      }

      setPaymentModeData(filteredModes);
    } else {
      setPaymentModeData([]);
    }
  };

  const fetchStoreCustomerAccount = () => {
    getStoreCustomerAccount(storeCustomerId, storeId)
      .then((response) => {
        if (!response.data.error) {
          const StoreCustomerAccountResponse = response.data;
          if (subscriptionDiscount === 0 || subscriptionDiscount === null) {
            StoreCustomerAccountResponse.advanceUnit =
              Number(Number(StoreCustomerAccountResponse.advanceUnit -
                StoreCustomerAccountResponse.subscriptionUnit)?.toFixed(enabledAmountRoundOff));
          }
          setStoreCustomerAccountResponse(StoreCustomerAccountResponse);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchLocalChargesAndDiscount = async () => {
    const { chargesAndDiscount } = getLocalChargesAndDiscount();
    if (chargesAndDiscount && Object.keys(chargesAndDiscount).length > 0) {
      const [chargeArray, discountArray] = chargesAndDiscount.reduce(
        ([charges, discounts], item) => {
          if (
            item.chargeDiscountMode === "ALL" ||
            item.chargeDiscountMode === "DELIVERY"
          ) {
            if (item.chargeDiscountType === "CHARGE") charges.push(item);
            if (item.chargeDiscountType === "DISCOUNT") discounts.push(item);
          }
          return [charges, discounts];
        },
        [[], []]
      );

      setCharges(chargeArray);
      setDiscounts(discountArray);
    } else {
      setCharges([]);
      setDiscounts([]);
    }
  };

  useEffect(() => {
    fetchLocalChargesAndDiscount();
    fetchLocalPaymentMode();
    fetchStoreCustomerAccount();
  }, [collectPaymentSubscriptionClosedModalVisible]);

  const fetchLocalStorePaymentGatewayConfig = async () => {
    const { storePaymentGatewayConfig } = getLocalStorePaymentGatewayConfig();
    if (
      storePaymentGatewayConfig &&
      Object.keys(storePaymentGatewayConfig).length > 0
    ) {
      setStorePaymentGatewayData(storePaymentGatewayConfig);
    } else {
      setStorePaymentGatewayData([]);
    }
  };

  useEffect(() => {
    fetchLocalStorePaymentGatewayConfig();
  }, [enabledCreatePaymentLink]);

  const balanceAmountCal = balanceAmount.toString();
  // Function to reset the state variables
  const resetFields = () => {
    setReceiveAmountValue("");
    setBalanceAmountValue(balanceAmountCal);
    setPaymentMethodValue("");
    setPaymentError("");
    setReceiveAmountError("");
    // ... (reset other fields if needed)
  };

  useEffect(() => {
    // Do something when modal is closed
    if (!collectPaymentSubscriptionClosedModalVisible) {
      // onClose && onClose();
      // Reset fields when modal is closed
      if (subscriptionDiscount === 0 || subscriptionDiscount === null) {
        resetFields();
      } else {
        let balanceAmountValueUpdate = 0;
        setBalanceAmountValue(balanceAmountValueUpdate.toString());
      }
    }
  }, [collectPaymentSubscriptionClosedModalVisible]);

  // Initialize a state variable for storing pickup requests
  const [paymentError, setPaymentError] = useState("");
  const [receiveAmountError, setReceiveAmountError] = useState("");

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };



  useEffect(() => {
    setBalanceAmountValue(balanceAmountCal);
  }, [balanceAmountCal]);

  const handleAddMorePaymentMethod = () => {
    setAddMorePaymentMethod(!addMorePaymentMethod);
  };

   
  const handleReceiveAmountChange = (text) => {
    // resetMethod();

    if (!isRoundOffMode && text === ".") {
      setReceiveAmountValue(".");
      return;
    }

    if (!inputRegex.test(text)) return;
    const receivedAmount = parseFloat(text);
    const finalValue = isRoundOffMode ? String(Math.round(receivedAmount)) : text;

    // Reset the discountAmount to 0 when receiveAmountValue changes
    setDiscountAmount(0);
    setAddDiscountValue("");
    handleDiscountRemove();
    setPaymentMethodSecondValue("");
    setPaymentSecondError("");

    const userAccountBalanceAmount =
      Number(Number(storeCustomerAccountResponse?.advanceUnit || 0)?.toFixed(enabledAmountRoundOff));

    if (
      paymentMethodValue === "USER_ACCOUNT" &&
      Number(finalValue || 0) > Number(userAccountBalanceAmount)
    ) {
      setUserAccountLowBalanceError("Your Account Balance is Low");
    } else {
      setUserAccountLowBalanceError("");
    }

    if (text !== "" && finalValue <= parseFloat(balanceAmountCal)) {
      setReceiveAmountValue(text);
      setReceiveAmountSecondValue("");
      setAddMorePaymentMethod(false);
      if (finalValue > 0) {
        setReceiveAmountError("");
        setUserAccountBalanceAmountError("");
        if (paymentMethodValue === "") {
          setPaymentError("Please select any Payment Method");
        } else {
          setPaymentError("");
        }
      } else if (finalValue === 0) {
        setReceiveAmountError("");
      } else {
        setReceiveAmountError("Please Enter Receive Amount");
      }
      // updateBalanceAmount(finalValue, discountAmount);
      // updateBalanceAmount(finalValue, 0);
      updateBalanceAmount(finalValue, 0, 0);
    } else {
      setReceiveAmountValue("");
      // setBalanceAmountValue(balanceAmountCal);s
      setBalanceAmountValue(
        discountAmount !== ""
          ? (balanceAmount - discountAmount).toString()
          : balanceAmountCal
      );
      setPaymentError("");
      if (paymentMethodValue !== "") {
        setReceiveAmountError("Please Enter Receive Amount");
      }
    }
  };

  const handleReceiveAmountSecondChange = (text) => {
    // resetMethod();
    if (!isRoundOffMode && text === ".") {
      setReceiveAmountValue(".");
      return;
    }

    if (!inputRegex.test(text)) return;

    const receivedAmountSecond = parseFloat(text);
    const finalValue = isRoundOffMode ? String(Math.round(receivedAmountSecond)) : text;


    // Reset the discountAmount to 0 when receiveAmountValue changes
    setDiscountAmount(0);
    setAddDiscountValue("");
    handleDiscountRemove();


    const userAccountBalanceAmount =
      Number(Number(storeCustomerAccountResponse?.advanceUnit || 0)?.toFixed(enabledAmountRoundOff));

    if (
      paymentMethodSecondValue === "USER_ACCOUNT" &&
      Number(finalValue || 0) > Number(userAccountBalanceAmount)
    ) {
      setUserAccountLowBalanceError("Your Account Balance is Low");
    } else {
      setUserAccountLowBalanceError("");
    }


    const primaryAmount = parseFloat(receiveAmountValue || 0);
    if (
      text !== "" &&
      finalValue <= parseFloat(balanceAmountCal) - primaryAmount
    ) {
      setReceiveAmountSecondValue(text);
      if (finalValue > 0) {
        setReceiveAmountSecondError("");
        if (paymentMethodSecondValue === "") {
          setPaymentSecondError("Please select any Payment Method");
        } else {
          setPaymentSecondError("");
        }
      } else if (finalValue === 0) {
        setReceiveAmountSecondError("");
      } else {
        setReceiveAmountSecondError("Please Enter Receive Amount");
      }
      // updateBalanceAmount(receivedAmount, discountAmount);
      updateBalanceAmount(primaryAmount, finalValue, 0);
    } else {
      setReceiveAmountSecondValue("");
      // setBalanceAmountValue(balanceAmountCal);s
      setBalanceAmountValue(
        discountAmount !== ""
          ? (balanceAmount - discountAmount).toString()
          : balanceAmountCal
      );
      setPaymentSecondError("");
      if (paymentMethodSecondValue !== "") {
        setReceiveAmountSecondError("Please Enter Receive Amount");
      }
    }
  };

  const handleBalanceAmountChange = (text) => {
    setBalanceAmountValue(text);
  };

  const handlePaymentMethodChange = (method) => {
    setPaymentMethodValue(method);
    setPaymentError("");
    setUserAccountBalanceAmountError("");
    setReceiveAmountValue("");
    setReceiveAmountSecondValue("");
    setAddMorePaymentMethod(false);
    setPaymentMethodSecondValue("");
    setPaymentSecondError("");
    setUserAccountLowBalanceError("");
    setReceiveAmountSecondError("");
    const filteredPaymentModes = paymentModeData.filter(
      (item) => item !== method && item !== "ONLINE"
    );
    setSecondPaymentModeData(filteredPaymentModes);
    setReceiveAmountError("Please Enter Receive Amount");
    let userAccountBalanceAmount = Number(Number(storeCustomerAccountResponse.advanceUnit)?.toFixed(enabledAmountRoundOff));
    if (method === "USER_ACCOUNT") {
      setReceiveAmountError("");
      if (!enableUserAccountDeliveryDiscount) {
        if (userAccountBalanceAmount < balanceAmount) {
          setUserAccountBalanceAmountError("Your Account Balance is Low");
          handleReceiveAmountChange("");
        } else {
          handleReceiveAmountChange(balanceAmount.toString());
          setReceiveAmountValue(balanceAmount.toString());
        }
      } else {
        setUserAccountBalanceAmountError("");
      }
    } else if (receiveAmountValue === "" || 0) {
      setReceiveAmountError("Please Enter Receive Amount");
      setUserAccountBalanceAmountError("");
    }
  };

  const handlePaymentMethodSecondChange = (method) => {
    setPaymentMethodSecondValue(method);
    setPaymentSecondError("");
    setReceiveAmountSecondValue("");
    setUserAccountLowBalanceError("");
    if (method === "USER_ACCOUNT") {
      setReceiveAmountSecondError("");
      if (!enableUserAccountDeliveryDiscount) {
        let userAccountBalanceAmount = Number(Number(storeCustomerAccountResponse.advanceUnit)?.toFixed(enabledAmountRoundOff));
        if (userAccountBalanceAmount < balanceAmount) {
          setUserAccountBalanceAmountError("Your Account Balance is Low");
        } else {
          setReceiveAmountSecondValue(balanceAmount.toString());
        }
      } else {
        setUserAccountBalanceAmountError("");
      }
    } else if (receiveAmountSecondValue === "" || 0) {
      setReceiveAmountSecondError("Please Enter Receive Amount");
      setUserAccountBalanceAmountError("");
    }
  };

  // const addDiscountsData = discounts.map((item, index) => ({
  //   id: index + 1,
  //   chargeDiscountId: item.id,
  //   name: item.name,
  //   amount: item.chargeDiscount,
  //   chargeDiscountType: item.chargeDiscountType,
  //   chargeDiscountTypeIn: item.chargeDiscountTypeIn,
  //   description: item.description,
  //   orderChargeDiscountMode: item.chargeDiscountMode,
  // }));

  // const dropdownItemsDiscount = addDiscountsData.filter(
  //   (discount) =>
  //     !selectedDiscount.some(
  //       (selectedDiscount) => selectedDiscount.id === discount.id
  //     )
  // );
 

  // const handleAddDiscountChange = (discount) => {
  //   setAddDiscount(discount);
  //   setAddDiscountValue(discount.name);
  //   let additionalDiscounts = 0;

  //   if (discount.chargeDiscountTypeIn === "AMOUNT") {
  //     additionalDiscounts = discount.amount;
  //   } else if (discount.chargeDiscountTypeIn === "PERCENTAGE") {
  //     additionalDiscounts =
  //       (parseInt(balanceAmountCal) * discount.amount) / 100;
  //   }

  //   if (
  //     parseInt(balanceAmountCal) -
  //     (parseInt(receiveAmountValue) +
  //       parseInt(receiveAmountSecondValue || 0)) <
  //     additionalDiscounts
  //   ) {
  //     additionalDiscounts =
  //       parseInt(balanceAmountCal) -
  //       (parseInt(receiveAmountValue) +
  //         parseInt(receiveAmountSecondValue || 0));
  //   }

  //   setDiscountAmount(additionalDiscounts);
  //   updateBalanceAmount(
  //     receiveAmountValue,
  //     receiveAmountSecondValue,
  //     additionalDiscounts
  //   );
  // };

  const updateBalanceAmount = (primaryAmount, secondaryAmount, discount) => {
    // const secondaryAmount = parseInt(receiveAmountSecondValue || 0);
    const receivedTotal =
      Number(Number(primaryAmount || 0)?.toFixed(enabledAmountRoundOff)) + Number(Number(secondaryAmount || 0)?.toFixed(enabledAmountRoundOff));
    const calculatedBalance =
      Number(Number((balanceAmountCal) - receivedTotal - discount)).toFixed(enabledAmountRoundOff);
    setBalanceAmountValue(calculatedBalance.toString());
  };

  const discountDropdownRef = useRef();
  const paymentMethodDropdownSecondRef = useRef();

  // useEffect(() => {
  //   if (subscriptionDiscount > 0) {
  //     setPaymentMethodValue('USER_ACCOUNT');
  //     let subscriptionDiscountValue = '';
  //     if (balanceAmount >= subscriptionDiscount) {
  //       subscriptionDiscountValue = balanceAmount - subscriptionDiscount;
  //     } else {
  //       subscriptionDiscountValue = balanceAmount;
  //     }
  //     setReceiveAmountValue(subscriptionDiscountValue.toString());
  //     let balanceAmountValueUpdate = 0;
  //     setBalanceAmountValue(balanceAmountValueUpdate.toString());
  //   }
  // }, [subscriptionDiscount]);

  useEffect(() => {
    if (subscriptionDiscount > 0) {
      // setPaymentMethodValue("USER_ACCOUNT");
      let subscriptionDiscountValue = "";
      if (!appliedSubscriptionDiscount) {
        subscriptionDiscountValue = balanceAmount - subscriptionDiscount;
      } else {
        subscriptionDiscountValue = balanceAmount;
      }
      // setReceiveAmountValue(subscriptionDiscountValue.toString());
      // setReceiveAmountValue(orderSubscriptionInfo?.offerApplyOn?.toString());
      // let balanceAmountValueUpdate = 0;
      setBalanceAmountValue(balanceAmount.toString());
    }
  }, [subscriptionDiscount]);

  const [
    checkedPackageSubscriptionOfferValue,
    setCheckedPackageSubscriptionOfferValue,
  ] = useState(null);

  const handleCheckPackageSubscriptionOffer = ({ selectedItemValue }) => {
    // if (selectedItemValue !== checkedPackageSubscriptionOfferValue) {
    setCheckedPackageSubscriptionOfferValue(selectedItemValue);
    if (selectedItemValue !== null) {
      setPackageSubscriptionOfferDefault(brandId, storeId, selectedItemValue)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res.status) {
              const data = {
                id: bookingOrderId,
                storeUserId: storeUserId,
                editByUserName:
                  userProfileData?.firstName + userProfileData?.lastName,
                autoApplySubscriptionWithPackage: selectedItemValue > 0 ? true : false,
              };

              setOrderPackageSubscription(
                storeId,
                storeCustomerId,
                bookingOrderId,
                data
              )
                .then((response) => {
                  if (!response.data.error) {
                    const Res = response.data;
                    const message = Res.message;
                    const status = Res.status;
                    setCollectPaymentSubscriptionClosedModalVisible(false);
                    setCheckedPackageSubscriptionOfferValue(null);
                    sendResponse({
                      message,
                      status,
                      modalFun: false,
                    });
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
    // }
  };

  const handleDiscountRemove = () => {
    setAddDiscountValue("");
    setDiscountAmount(0);
    updateBalanceAmount(receiveAmountValue, receiveAmountSecondValue, 0);
    if (discountDropdownRef.current) {
      discountDropdownRef.current.reset();
    }
  };

  const handlePaymentLinkPress = (paymentLink) => {
    window.open(paymentLink, "_blank");
    setCollectPaymentSubscriptionClosedModalVisible(!collectPaymentSubscriptionClosedModalVisible);
    setIsPayNowButtonPressed(false);
  };

  const handlePaymentLink = () => {
    if (!isPayNowButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsPayNowButtonPressed(true);
      const gatewayData = {
        storeGatewayId: storePaymentGatewayData[0]?.id,
        storeCustomerId: storeCustomerId,
        orderId: bookingOrderId,
        requestAmount: Number(Number(receiveAmountValue)?.toFixed(enabledAmountRoundOff)),
        notify: false,
        storeUserId: storeUserId,
        forceCreate: true,
      };
      GeneratePaymentLink(gatewayData)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res.paymentLink !== "") {
              // setResponseData(Res);

              navigate("/ThankYouCollectPayment", {
                state: {
                  storeCustomerId: storeCustomerId,
                  bookingOrderId: bookingOrderId,
                },
              });
              handlePaymentLinkPress(Res.paymentLink);
              setIsPayNowButtonPressed(false);
            } else {
              setIsPayNowButtonPressed(false);
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const handleCollectPayment = () => {
    if (paymentMethodValue === "") {
      setPaymentError("Please select any Payment Method");
    } else if (receiveAmountValue === "") {
      setReceiveAmountError("Please Enter Receive Amount");
    } else {
      setPaymentError("");
      setReceiveAmountError("");
      let userAccountBalanceAmount = Number(Number(storeCustomerAccountResponse.advanceUnit)?.toFixed(enabledAmountRoundOff));
      if (
        paymentMethodValue === "USER_ACCOUNT" &&
        userAccountBalanceAmount < Number(Number(receiveAmountValue)?.toFixed(enabledAmountRoundOff))
      ) {
        setUserAccountBalanceAmountError("Your Account Balance is Low");
        setIsPayNowButtonPressed(false);
      } else {
        if (!isPayNowButtonPressed) {
          // Set the state to indicate that the button has been pressed
          setIsPayNowButtonPressed(true);
          const otherPaymentInfoDTO = {
            amount: Number(Number(receiveAmountSecondValue)?.toFixed(enabledAmountRoundOff)),
            paymentMode: paymentMethodSecondValue,
          };

          const data = {
            receivedBy: storeUserId,
            paidBy: storeCustomerId,
            amount: Number(Number(receiveAmountValue)?.toFixed(enabledAmountRoundOff)),
            paymentMode: paymentMethodValue,
          };

          const discountDataCal = {
            ...addDiscount,
            amount: discountAmount,
          };

          const submitData = {
            paymentDTO: data,
            otherPaymentInfo: otherPaymentInfoDTO,
            orderChargeDiscountDTO: discountDataCal,
          };

          const subscriberOfferData = { applied: true };

          if (subscriptionDiscount > 0) {
            if (appliedSubscriptionDiscount === false) {
              subscriberOffer(
                storeCustomerId,
                storeId,
                bookingOrderId,
                subscriberOfferData
              )
                .then((response) => {
                  if (!response.data.error) {
                    const Res = response.data;

                    if (Res.status) {
                      orderMultiplePaymentSettlement(
                        storeCustomerId,
                        storeId,
                        bookingOrderId,
                        submitData
                      )
                        .then((response) => {
                          if (!response.data.error) {
                            const Res = response.data;
                            const message = Res.message;
                            const status = Res.status;
                            setCollectPaymentSubscriptionClosedModalVisible(false);
                            sendResponse({
                              message,
                              status,
                              modalFun: false,
                            });
                            setIsPayNowButtonPressed(false);
                            handleDiscountRemove();
                            setPaymentMethodSecondValue("");
                            setPaymentSecondError("");
                            setReceiveAmountSecondValue("");
                            setAddMorePaymentMethod(false);
                            setReceiveAmountSecondError("");
                          }
                        })
                        .catch((err) => {
                          console.error("Error:", err);
                        });
                    }
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            } else {
              orderMultiplePaymentSettlement(
                storeCustomerId,
                storeId,
                bookingOrderId,
                submitData
              )
                .then((response) => {
                  if (!response.data.error) {
                    const Res = response.data;
                    const message = Res.message;
                    const status = Res.status;
                    setCollectPaymentSubscriptionClosedModalVisible(false);
                    sendResponse({
                      message,
                      status,
                      modalFun: false,
                    });
                    setIsPayNowButtonPressed(false);
                    handleDiscountRemove();
                    setPaymentMethodSecondValue("");
                    setPaymentSecondError("");
                    setReceiveAmountSecondValue("");
                    setAddMorePaymentMethod(false);
                    setReceiveAmountSecondError("");
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            }
          } else {
            orderMultiplePaymentSettlement(
              storeCustomerId,
              storeId,
              bookingOrderId,
              submitData
            )
              .then((response) => {
                if (!response.data.error) {
                  const Res = response.data;
                  const message = Res.message;
                  const status = Res.status;
                  setCollectPaymentSubscriptionClosedModalVisible(false);
                  sendResponse({
                    message,
                    status,
                    modalFun: false,
                  });
                  setIsPayNowButtonPressed(false);
                  handleDiscountRemove();
                  setPaymentMethodSecondValue("");
                  setPaymentSecondError("");
                  setReceiveAmountSecondValue("");
                  setAddMorePaymentMethod(false);
                  setReceiveAmountSecondError("");
                }
              })
              .catch((err) => {
                console.error("Error:", err);
              });
          }
        }
      }
    }
  };

  const [customerOrdersData, setCustomerOrdersData] = useState("")

  const [qrRes, setQrRes] = useState("")
  const [qrResStatus, setQrResStatus] = useState(false)

  const fetchCustomerSingleOrder = () => {
    // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
    getCustomerSingleOrderInfo(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOrdersData(Res.balanceAmount);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });
  }

  const [paymentDone, setPaymentDone] = useState(false);


  useEffect(() => {
    let intervalId;
    let timeoutId;
    let isCompleted = false; // ✅ prevents double execution

    if (qrResStatus && !paymentDone) {
      intervalId = setInterval(async () => {
        fetchCustomerSingleOrder(); // ✅ get fresh value

        if (customerOrdersData === 0.0 && !isCompleted) {
          isCompleted = true;

          clearInterval(intervalId);
          clearTimeout(timeoutId);

          setPaymentDone(true);

          await sendScreen("success");

          setCollectPaymentSubscriptionClosedModalVisible(false);

          sendResponse({
            message: "success",
            status: "success",
            modalFun: false,
          });

          setIsPayNowButtonPressed(false);
          handleDiscountRemove();
          setPaymentMethodSecondValue("");
          setPaymentSecondError("");
          setReceiveAmountSecondValue("");
          setAddMorePaymentMethod(false);
          setReceiveAmountSecondError("");
        }
      }, 5000);

      // ✅ 30 sec timeout
      timeoutId = setTimeout(async () => {
        if (!isCompleted) {
          isCompleted = true;

          clearInterval(intervalId);

          setPaymentDone(true);

          await sendScreen("fail");

          setCollectPaymentSubscriptionClosedModalVisible(false);

          sendResponse({
            message: "failed",
            status: "failed",
            modalFun: false,
          });

          setQrRes("Payment timeout");
        }
      }, 300000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [qrResStatus, paymentDone, customerOrdersData]);

  const handleModalClose = () => {
    setCollectPaymentSubscriptionClosedModalVisible(!collectPaymentSubscriptionClosedModalVisible);
    setIsPayNowButtonPressed(false);
    setUserAccountBalanceAmountError("");
    handleDiscountRemove();
    setPaymentMethodSecondValue("");
    setPaymentSecondError("");
    setReceiveAmountSecondValue("");
    setAddMorePaymentMethod(false);
    setReceiveAmountSecondError("");
    // onClose();
  };



  // your existing states


  // const upiAccountLinkCreated =
  //   "upi://pay?pa=" +
  //   upiAccountId +
  //   "&pn=" +
  //   upiAccountName +
  //   "&am=" +
  //   balanceAmountValue +
  //   "&tn=" +
  //   bookingOrderId;

  const upiAccountLinkCreated =
    "upi://pay?pa=" +
    upiAccountId +
    "&pn=" +
    upiAccountName +
    "&tr=MNO" +
    bookingOrderNo +
    "&am=" +
    balanceAmountValue +
    "&cu=INR&mc=5411"
  // ---------------- HELPERS ----------------

  function getBaseUrl() {
    return `http://127.0.0.1:8053`;
  }

  function getEndpoint(type) {
    return {
      qr: "/rgb565/qr",
      success: "/rgb565/success",
      fail: "/rgb565/fail",
    }[type];
  }

  function drawCenteredText(ctx, text, font, y) {
    ctx.font = font;
    ctx.fillStyle = "black";
    const x = (DISPLAY_W - ctx.measureText(text).width) / 2;
    ctx.fillText(text, x, y);
  }

  function toRGB565Blob(canvas) {
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    const data = ctx.getImageData(0, 0, DISPLAY_W, DISPLAY_H).data;

    const out = new Uint8Array(DISPLAY_W * DISPLAY_H * 2);
    let idx = 0;

    for (let i = 0; i < DISPLAY_H; i++) {
      for (let j = 0; j < DISPLAY_W; j++) {
        const src = ((DISPLAY_H - 1 - i) * DISPLAY_W + j) * 4;

        const r = (data[src] >> 3) & 0x1f;
        const g = (data[src + 1] >> 2) & 0x3f;
        const b = (data[src + 2] >> 3) & 0x1f;

        const px = (r << 11) | (g << 5) | b;

        out[idx++] = (px >> 8) & 0xff;
        out[idx++] = px & 0xff;
      }
    }

    return new Blob([out], { type: "application/octet-stream" });
  }

  async function fetchImage(url) {
    const resp = await fetch(url);
    if (!resp.ok) throw new Error("Image load failed");

    const blob = await resp.blob();
    const objectUrl = URL.createObjectURL(blob);

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(objectUrl);
        resolve(img);
      };
      img.onerror = reject;
      img.src = objectUrl;
    });
  }

  async function drawBackground(url) {
    const canvas = document.getElementById("canvas");
    canvas.width = DISPLAY_W;
    canvas.height = DISPLAY_H;

    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.clearRect(0, 0, DISPLAY_W, DISPLAY_H);

    const img = await fetchImage(url);
    ctx.drawImage(img, 0, 0, DISPLAY_W, DISPLAY_H);

    return ctx;
  }

  // ---------------- CORE RENDER ----------------

  async function renderScreen(type) {
    const canvas = document.getElementById("canvas");
    const ctx = canvas.getContext("2d", { willReadFrequently: true });

    if (type === "qr") {
      await drawBackground(
        "https://download.rechargegrid.in/download/general/image/jpeg/_background.jpg"
      );

      const overlayCanvas = document.getElementById("overlayCanvas");

      await QRCode.toCanvas(overlayCanvas, upiAccountLinkCreated, {
        width: 260,
        margin: 1,
      });

      ctx.drawImage(overlayCanvas, 30, 150, 260, 260);

      drawCenteredText(ctx, storeLocalData?.currencySymbol + " " + balanceAmountValue, "bold 30px Arial", 130);
      drawCenteredText(ctx, "UPI ID: " + upiAccountId, "20px Arial", 440);
    }

    if (type === "fail") {
      await drawBackground("https://download.rechargegrid.in/download/general/image/jpeg/_fail.jpg");
      return;
    }

    if (type === "success") {
      await drawBackground(
        "https://download.rechargegrid.in/download/general/image/jpeg/_success.jpg"
      );

      drawCenteredText(
        ctx,
        storeLocalData?.currencySymbol + " " + (balanceAmountValue || "0.00"),
        "32px Arial",
        260
      );
    }
  }

  // ---------------- SEND TO DEVICE ----------------

  async function sendScreen(type) {
    try {
      await renderScreen(type);

      const endpoint = getEndpoint(type);
      if (!endpoint) throw new Error("Invalid type");

      const canvas = document.getElementById("canvas");

      const fd = new FormData();
      fd.append("file", toRGB565Blob(canvas), "image.bin");

      const resp = await fetch(getBaseUrl() + endpoint, {
        method: "POST",
        body: fd,
      });

      const text = await resp.text();

      if (resp.status === 200 && type === "qr") {
        setQrResStatus(true);
      }

      setQrRes("Response: " + text);
    } catch (err) {
      setQrRes("Error: " + err.message);
    }
  }

  // ---------------- BUTTON ----------------

  const handleSendQr = () => {
    setPaymentDone(false); // reset
    sendScreen("qr");
    // sendScreen("success");
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={collectPaymentSubscriptionClosedModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!collectPaymentSubscriptionClosedModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"}
                  style={{
                    width: 40,
                    height: 40,
                  }}
                />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Collect Payment
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="flex justify-content-between align-items-center"
              style={{
                paddingLeft: "20px",
                paddingRight: "20px",
                borderRadius: "16px",
                // background: "linear-gradient(135deg, #eef2ff, #ffffff)",
                // boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                flexWrap: "wrap",
              }}
            >
              {/* LEFT SECTION */}
              <div className="flex" style={{ gap: "12px" }}>
                {/* Wallet Balance */}
                {Number(Number(storeCustomerAccountResponse.advanceUnit)?.toFixed(enabledAmountRoundOff)) > 0 && <div
                  style={{
                    background: "#ffffff",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                  }}
                >
                  <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
                    Available Wallet Balance
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "24px",
                      fontWeight: "700",
                      color: "#16a34a",
                    }}
                  >
                    {storeLocalData?.currencySymbol} {Number(Number(storeCustomerAccountResponse.advanceUnit)?.toFixed(enabledAmountRoundOff))}
                  </p>
                </div>}

                {/* Subscription */}
                {storeCustomerAccountResponse.subscriptionUnit > 0 && (
                  <div
                    style={{
                      background: "#ffffff",
                      padding: "12px 16px",
                      borderRadius: "10px",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
                      Available Subscription
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "24px",
                        fontWeight: "700",
                        color: "#2563eb",
                      }}
                    >
                      {storeLocalData?.currencySymbol} {Number(Number(storeCustomerAccountResponse.subscriptionUnit)?.toFixed(enabledAmountRoundOff))}
                    </p>
                  </div>
                )}
              </div>

              {/* RIGHT SECTION (QR) */}
              {enabledUPIAccount && upiAccountId && balanceAmount > 0 && (
                <div
                  className="flex flex-column align-items-center"
                  style={{
                    background: "#ffffff",
                    padding: "8px",
                    borderRadius: "14px",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                    // minWidth: "140px",
                  }}
                >
                  <img
                    src={
                      STORE_BASE_URL +
                      `/store/api/secure/v1/qr-code/qr-by-text/` +
                      bookingOrderId +
                      `/50/50`
                    }
                    alt="QR Code"
                    onClick={() => {
                      setShowQRModal(true)
                      if(enabledQRDeviceModal)  {
                        handleSendQr()
                      }
                    }}
                    style={{
                      // width: "60px",
                      // height: "60px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      transition: "0.3s",
                    }}
                  />
                  <p style={{ fontSize: "12px", marginTop: "6px" }}>
                    Tap to enlarge
                  </p>
                </div>
              )}
            </div>

            <div style={{ display: "none" }} class="right">
              <h3 >Preview</h3>
              <canvas id="canvas" width="320" height="480"></canvas>
              <canvas id="overlayCanvas" width="260" height="260" ></canvas>
              <div id="status">Ready</div>
            </div>

            {showQRModal && (
              <div
                onClick={() => setShowQRModal(false)}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0,0,0,0.7)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 9999,
                }}
              >
                {/* STOP CLOSE WHEN CLICKING INSIDE */}
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    position: "relative",
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "16px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                    textAlign: "center",
                  }}
                >
                  {/* CLOSE BUTTON */}
                  <div
                    onClick={() => setShowQRModal(false)}
                    style={{
                      position: "absolute",
                      top: "7px",
                      right: "7px",
                      fontSize: "20px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      color: "#444",
                    }}
                  >
                    ✕
                  </div>

                  {/* BIG QR */}
                  <img
                    src={
                      STORE_BASE_URL +
                      `/store/api/secure/v1/qr-code/qr-by-text/` +
                      bookingOrderId +
                      `/250/250`
                    }
                    alt="QR Large"
                    style={{
                      width: "220px",
                      height: "220px",
                      borderRadius: "10px",
                    }}
                  />

                  <p style={{ marginTop: "12px", fontWeight: "600" }}>
                    Scan to Pay
                  </p>
                  <Button
                      className="mt-1 mb-3 mx-4 border-round-xl "
                      onClick={() => {
                        sendResponseQrPayment({
                          modalFun: false,
                        });
                        setCollectPaymentSubscriptionClosedModalVisible(false);
                        setIsPayNowButtonPressed(false);
                        handleDiscountRemove();
                        setPaymentMethodSecondValue("");
                        setPaymentSecondError("");
                        setReceiveAmountSecondValue("");
                        setAddMorePaymentMethod(false);
                        setReceiveAmountSecondError("");
                      }}
                      >
                    <p className=" w-full text-2xl font-semibold flex justify-content-center">
                      Check Status
                    </p>
                    </Button>
                </div>
              </div>
            )}
            {!qrResStatus && <>

              <div>
                <div>
                  {balanceAmount > 0 &&
                    enabledSubscriptionDiscountOnDelivery &&
                    receiveAmountValue === "" &&
                    paymentMethodValue === "" &&
                    paidAmount === 0 &&
                    (subscriptionDiscount === 0 ||
                      subscriptionDiscount === null) && (
                      <CollectPaymentPackageSubscriptionOfferDefault
                        storeCustomerId={storeCustomerId}
                        storeId={storeId}
                        storeUserId={storeUserId}
                        grandTotal={Math.round(balanceAmount)}
                        onChecked={handleCheckPackageSubscriptionOffer}
                        enabledApplySubscriptionWithPackage={enabledApplySubscriptionWithPackage}
                        enabledAutoApplySubscriptionWithPackage={enabledAutoApplySubscriptionWithPackage}
                        orderPackageData={orderPackageData}
                      />
                    )}
                </div>
              </div>

              <div className="flex flex-1 flex-row">
                <div className="mx-4 flex-1">
                  <div
                    className="flex-1"
                    // style={{
                    //   pointerEvents:
                    //     paymentMethodValue === "USER_ACCOUNT" &&
                    //       subscriptionDiscount > 0
                    //       ? "none"
                    //       : "auto",
                    // }}
                  >
                    <p>Payment Method</p>
                    <Dropdown
                      value={paymentMethodValue}
                      onChange={(e) => handlePaymentMethodChange(e.value)}
                      options={paymentModeData}
                      optionLabel="name"
                      placeholder="Payment Method"
                      // disabled={
                      //   paymentMethodValue === "USER_ACCOUNT" &&
                      //   subscriptionDiscount > 0
                      // }
                      className="w-full  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                    />
                  </div>

                  <div>
                    {paymentError !== "" && (
                      <p className="text-md" style={{ color: "red" }}>
                        {paymentError}
                      </p>
                    )}
                  </div>
                </div>
                <div
                  className="mx-4 flex-1"
                  // style={{
                  //   pointerEvents:
                  //     paymentMethodValue === "USER_ACCOUNT" &&
                  //       subscriptionDiscount > 0
                  //       ? "none"
                  //       : "auto",
                  // }}
                >
                  <p className="text-md font-normal">Receive Amount</p>
                  <InputText
                    value={receiveAmountValue}
                    onChange={(e) => handleReceiveAmountChange(e.target.value)}
                    className="w-full text-xl  border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                    keyboardType="numeric"
                    // editable={
                    //   paymentMethodValue === "USER_ACCOUNT"
                    //     ? enableUserAccountDeliveryDiscount
                    //       ? true
                    //       : false
                    //     : true
                    // }
                  />
                </div>
                {!(
                  paymentMethodValue === "ONLINE" ||
                  parseFloat(balanceAmountValue) === 0
                ) &&
                  !userAccountLowBalanceError &&
                  paymentMethodValue &&
                  receiveAmountValue &&
                  !addMorePaymentMethod && (
                    <div
                      className="mx-2 flex w-1 justify-content-center align-items-center cursor-pointer"
                      onClick={handleAddMorePaymentMethod}
                      style={{
                        background: "#2B70D7",
                        borderRadius: 5,
                        position: "relative",
                        height: 44,
                        top: 21,
                      }}
                    >
                      <p className="text-xl font-bold text-white">+</p>
                    </div>
                  )}
              </div>
              {paymentMethodValue &&
                receiveAmountValue &&
                addMorePaymentMethod && (
                  <div className="flex flex-1 flex-row">
                    <div className="mx-4 flex-1">
                      <div
                        className="flex-1"
                      >
                        <p>Payment Method</p>
                        <Dropdown
                          value={paymentMethodSecondValue}
                          onChange={(e) =>
                            handlePaymentMethodSecondChange(e.value)
                          }
                          options={secondPaymentModeData}
                          optionLabel="name"
                          placeholder="Payment Method"
                          disabled={
                            paymentMethodSecondValue === "USER_ACCOUNT" &&
                            subscriptionDiscount > 0
                          }
                          className="w-full  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                        />
                      </div>

                      <div>
                        {paymentError !== "" && (
                          <p className="text-md" style={{ color: "red" }}>
                            {paymentError}
                          </p>
                        )}
                      </div>
                    </div>
                    <div
                      className="mx-4 flex-1"
                      style={{
                        pointerEvents:
                          paymentMethodValue === "USER_ACCOUNT" &&
                            subscriptionDiscount > 0
                            ? "none"
                            : "auto",
                      }}
                    >
                      <p className="text-md font-normal">Receive Amount</p>
                      <InputText
                        value={receiveAmountSecondValue}
                        onChange={(e) =>
                          handleReceiveAmountSecondChange(e.target.value)
                        }
                        className="w-full text-xl  border-round-xl shadow-2"
                        style={{
                          backgroundColor: "#fff",
                        }}
                        keyboardType="numeric"
                        editable={
                          paymentMethodSecondValue === "USER_ACCOUNT"
                            ? enableUserAccountDeliveryDiscount
                              ? true
                              : false
                            : true
                        }
                      />
                    </div>
                  </div>
                )}
              {receiveAmountError !== "" && (
                <div className="mx-4">
                  <p className="text-lg font-normal" style={{ color: "red" }}>
                    {receiveAmountError}
                  </p>
                </div>
              )}

              {paymentSecondError !== "" && (
                <div className="flex flex-1 mx-4 my-2">
                  <p
                    className="text-lg font-normal mt-2"
                    style={{ color: "red" }}
                  >
                    {paymentSecondError}
                  </p>
                </div>
              )}

              <div>
                {receiveAmountSecondError !== "" && (
                  <div className="mx-4">
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {receiveAmountSecondError}
                    </p>
                  </div>
                )}
              </div>
              <div
                className="mx-4"
                style={{
                  pointerEvents: "none",
                }}
              >
                <p className="text-md font-normal">Balance Amount</p>
                <InputText
                  value={balanceAmountValue}
                  onChange={(e) => handleBalanceAmountChange(e.target.value)}
                  className="w-full text-xl  border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  keyboardType="numeric"
                  editable={false}
                />
                <div className="mx-4">
                  {userAccountBalanceAmountError !== "" && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {userAccountBalanceAmountError}
                    </p>
                  )}
                </div>
                <div className="mx-4">
                  {userAccountLowBalanceError !== "" && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {userAccountLowBalanceError}
                    </p>
                  )}
                </div>
              </div>
              {/*balanceAmount > 0 && balanceAmountValue > 0 && (
                <div>
                  {(subscriptionDiscount === null ||
                    subscriptionDiscount === 0) && (
                      <div>
                        {paymentMethodValue !== "ONLINE" &&
                          deliveryDiscount &&
                          balanceAmountCal !== receiveAmountValue && (
                            <div className="flex-1 mx-4 ">
                              <div className="flex flex-1 ">
                                <Dropdown
                                  value={addDiscountValue.toString()}
                                  onChange={(e) => handleAddDiscountChange(e.value)}
                                  options={dropdownItemsDiscount}
                                  optionLabel="name"
                                  placeholder="Discount"
                                  className="w-full  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                                />
                              </div>
                            </div>
                          )}
                        {deliveryDiscount && discountAmount > 0 && (
                          <div className="mx-4">
                            <div>
                              <p className="text-md font-normal">Discount Amount</p>
                              <InputText
                                value={discountAmount.toString()}
                                // onChange={handleOtherRemarkChange}
                                className="w-full text-xl  border-round-xl shadow-2"
                                style={{
                                  backgroundColor: "#fff",
                                }}
                                onFocus={() => handleFocus("otherRemark")}
                                onBlur={handleBlur}
                                editable={false}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                </div>
              )*/}

              {paymentMethodValue === "ONLINE" ? (
                <Button
                  className="mt-1 mb-3 mx-4 border-round-xl "
                  onClick={handlePaymentLink}
                  disabled={isPayNowButtonPressed}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    RECEIVE PAYMENT
                  </p>
                </Button>
              ) : (
                <Button
                  className="mt-1 mb-3 mx-4 border-round-xl "
                  onClick={handleCollectPayment}
                  disabled={
                    userAccountBalanceAmountError || userAccountLowBalanceError
                      ? true
                      : checkedPackageSubscriptionOfferValue !== null
                        ? true
                        : receiveAmountError
                          ? true
                          : receiveAmountSecondError
                            ? true
                            : isPayNowButtonPressed
                  }
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    Pay Now
                  </p>
                </Button>
              )}
            </>}
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default CollectPaymentSubscriptionClosedModal;
